import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const navigate = useNavigate();
        const params = useParams();
        const location = useLocation();

        return (
            <Component
                {...props}
                navigate={navigate}
                params={params}
                location={location}
            />
        );
    }
    return ComponentWithRouterProp;
}
export default withRouter;